import { z } from "zod";

export const loginSchema = ({
  t,
  withCaptcha,
}: {
  t: (arg: string) => string;
  withCaptcha: boolean;
}) => {
  return z.object({
    contractCode: z
      .string()
      .min(1, { message: t("login.formValidation.requiredField") }),
    userCode: z
      .string()
      .min(1, { message: t("login.formValidation.requiredField") }),
    password: z
      .string()
      .min(1, { message: t("login.formValidation.requiredField") }),
    captcha: withCaptcha
      ? z.string().min(1, { message: t("login.formValidation.requiredField") })
      : z.string().optional(),
  });
};

export const loginResetPswSchema = ({
  t,
}: {
  t: (arg: string) => string;
}) => {
  return z.object({
    contractCode: z
    .string()
    .min(1, { message: t("login.formValidation.requiredField") }),
    userCode: z
    .string()
    .min(1, { message: t("login.formValidation.requiredField") }),
    fiscalCode: z
    .string()
    .min(1, { message: t("login.formValidation.requiredField") }),
  });
};

export type LoginFormType = z.infer<ReturnType<typeof loginSchema>>;
export type LoginResetPswFormType = z.infer<ReturnType<typeof loginResetPswSchema>>;
